import React, { useEffect, useState } from 'react';
import cx from 'classnames';

import { Button } from '@atlas/ui';

const LuckyDayDescription = ({ description, handleShowMore }) => {
  const [descriptionShowMore, setDescriptionShowMore] = useState(false);
  const [DOMPurify, installDOMPurify] = useState({});

  useEffect(() => {
    import('dompurify').then(DOMPurifyModule => {
      installDOMPurify({ ...DOMPurifyModule.default });
    });
  }, []);

  if (!description || !DOMPurify.sanitize) return null;

  const descriptionShowMoreClass = cx('luckyday__description', {
    'luckyday__description-less': description?.length > 160 && !descriptionShowMore,
  });

  return (
    <div className="description">
      <div
        className={descriptionShowMoreClass}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description, { FORCE_BODY: true }) }}
      />

      {description.length > 160 && (
        <Button
          label={descriptionShowMore ? 'read_less' : 'read_more'}
          onClick={handleShowMore(descriptionShowMore, setDescriptionShowMore)}
          size="medium"
          type="secondary"
        />
      )}
    </div>
  );
};

export default LuckyDayDescription;
